import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-5xl mx-auto sm:px-6 lg:px-8 pt-8 pb-12" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_4 = { class: "flex items-center gap-3 px-6 py-5 border-b border-white/5" }
const _hoisted_5 = { class: "bg-emerald-500/20 p-2.5 rounded-lg" }
const _hoisted_6 = { class: "divide-y divide-white/5" }
const _hoisted_7 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_8 = { class: "text-sm font-medium text-white" }
const _hoisted_9 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_10 = { class: "text-sm font-medium text-white truncate max-w-[60%]" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-between px-6 py-3.5"
}
const _hoisted_12 = { class: "text-sm font-medium text-white" }
const _hoisted_13 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_14 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_15 = { class: "flex items-center gap-3 px-6 py-5 border-b border-white/5" }
const _hoisted_16 = { class: "bg-emerald-500/20 p-2.5 rounded-lg" }
const _hoisted_17 = {
  key: 0,
  class: "divide-y divide-white/5"
}
const _hoisted_18 = { class: "px-6 py-4" }
const _hoisted_19 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_20 = { class: "bg-violet-500/15 p-1.5 rounded-md" }
const _hoisted_21 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_22 = { class: "bg-white/3 rounded-lg px-4 py-3" }
const _hoisted_23 = { class: "text-xl font-bold text-white" }
const _hoisted_24 = { class: "bg-white/3 rounded-lg px-4 py-3" }
const _hoisted_25 = { class: "text-xl font-bold text-white" }
const _hoisted_26 = { class: "px-6 py-4" }
const _hoisted_27 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_28 = { class: "bg-emerald-500/15 p-1.5 rounded-md" }
const _hoisted_29 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_30 = { class: "bg-white/3 rounded-lg px-4 py-3" }
const _hoisted_31 = { class: "text-xl font-bold text-white" }
const _hoisted_32 = {
  key: 1,
  class: "flex items-center justify-center py-14"
}
const _hoisted_33 = { class: "bg-white/5 rounded-xl overflow-hidden lg:col-span-2" }
const _hoisted_34 = { class: "flex items-center gap-3 px-6 py-5 border-b border-white/5" }
const _hoisted_35 = { class: "bg-emerald-500/20 p-2.5 rounded-lg" }
const _hoisted_36 = { class: "p-6 space-y-6" }
const _hoisted_37 = {
  key: 0,
  class: "flex flex-wrap items-center justify-between gap-3 bg-amber-500/10 border border-amber-500/20 rounded-lg px-4 py-3"
}
const _hoisted_38 = { class: "flex items-center gap-2 text-amber-300 text-sm" }
const _hoisted_39 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-3" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "divide-y divide-white/5 -mx-6 border-y border-white/5" }
const _hoisted_42 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_43 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_44 = { class: "flex items-center justify-between px-6 py-3.5" }
const _hoisted_45 = { class: "flex justify-end" }
const _hoisted_46 = { class: "grid gap-4 py-2" }
const _hoisted_47 = { class: "grid gap-2" }
const _hoisted_48 = { class: "grid gap-2" }
const _hoisted_49 = { class: "grid gap-2" }
const _hoisted_50 = {
  key: 0,
  class: "flex items-center gap-2 text-xs text-red-400"
}

import { onMounted, ref } from 'vue'
import { AlertCircle, Bell, BellOff, Bot, Building2, GitBranch, KeyRound, Loader2, Percent, Volume2 } from 'lucide-vue-next'
import Cookies from 'js-cookie'
import { usePaymentGatewayIntegration } from '@/composables/usePaymentGatewayIntegration'
import { useAuth, NotificationPreferences } from '@/composables/useAuth'
import { usePushNotification, playNotificationSound } from '@/composables/usePushNotification'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { useToast } from '@/components/ui/toast'
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const rawOrg = Cookies.get('organization')
  ? JSON.parse(Cookies.get('organization') as string)
  : {}
const org = rawOrg

const { list } = usePaymentGatewayIntegration()
const isLoading = ref(true)
const firstIntegration = ref<any>(null)

const { changePassword, getProfile, updateNotificationSettings } = useAuth()
const { requestPermission } = usePushNotification()
const { toast } = useToast()

const isChangePasswordOpen = ref(false)
const isChangingPassword = ref(false)
const passwordError = ref('')
const passwordForm = ref({ passwordOld: '', password: '', passwordConfirm: '' })

const soundOptions = [
  { id: 'cashregister', label: 'Caixa registradora' },
  { id: 'cash2', label: 'Dinheiro 1' },
  { id: 'cash3', label: 'Dinheiro 2' },
]

const notificationPermission = ref<NotificationPermission>(
  typeof Notification !== 'undefined' ? Notification.permission : 'denied'
)
const notificationPreferences = ref<NotificationPreferences>({ sale: true, pendingSale: true, botDown: true })
const notificationSound = ref('cashregister')
const isSavingNotifications = ref(false)

function handleSelectSound(soundId: string) {
  notificationSound.value = soundId
  playNotificationSound(soundId)
}

async function handleEnableNotifications() {
  await requestPermission()
  if (typeof Notification !== 'undefined') {
    notificationPermission.value = Notification.permission
  }
}

async function handleSaveNotifications() {
  isSavingNotifications.value = true
  try {
    await updateNotificationSettings({
      notification: notificationPreferences.value,
      notificationSound: notificationSound.value
    })
    toast({ title: 'Notificações atualizadas com sucesso', class: 'bg-green-500 text-white', duration: 2000 })
  } catch {
    toast({ title: 'Erro ao atualizar notificações', variant: 'destructive', duration: 2500 })
  } finally {
    isSavingNotifications.value = false
  }
}

function openChangePassword() {
  passwordForm.value = { passwordOld: '', password: '', passwordConfirm: '' }
  passwordError.value = ''
  isChangePasswordOpen.value = true
}

function formatDocument(doc: string): string {
  const d = doc.replace(/\D/g, '')
  if (d.length === 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  if (d.length === 14) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  return doc
}

function formatCurrency(v: number): string {
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

async function handleChangePassword() {
  passwordError.value = ''

  if (passwordForm.value.password.length < 8) {
    passwordError.value = 'A nova senha deve ter no mínimo 8 caracteres.'
    return
  }

  if (passwordForm.value.password !== passwordForm.value.passwordConfirm) {
    passwordError.value = 'A nova senha e a confirmação não coincidem.'
    return
  }

  isChangingPassword.value = true
  try {
    await changePassword(passwordForm.value)
    isChangePasswordOpen.value = false
    toast({ title: 'Senha alterada com sucesso', class: 'bg-green-500 text-white', duration: 2000 })
  } catch {
    passwordError.value = 'Senha atual incorreta ou erro ao alterar. Tente novamente.'
  } finally {
    isChangingPassword.value = false
  }
}

onMounted(async () => {
  try {
    const integrations = await list()
    if (integrations?.length) firstIntegration.value = integrations[0]
  } catch {
    // sem integração
  } finally {
    isLoading.value = false
  }
})

onMounted(async () => {
  try {
    const profile = await getProfile()
    notificationPreferences.value = {
      sale: profile.notification?.sale ?? true,
      pendingSale: profile.notification?.pendingSale ?? true,
      botDown: profile.notification?.botDown ?? true
    }
    notificationSound.value = profile.notificationSound || 'cashregister'
  } catch {
    // mantém os valores padrão
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mb-8" }, [
          _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-3" }, "Meu Perfil"),
          _createElementVNode("p", { class: "text-[#9CA3AF] leading-relaxed text-sm" }, " Informações da sua conta e taxas da plataforma. ")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Building2), { class: "h-5 w-5 text-emerald-400" })
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-base font-semibold text-white" }, "Informações da Conta", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-sm text-zinc-400" }, "Nome", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(org).name || '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-sm text-zinc-400" }, "E-mail", -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(org).contactEmail || '—'), 1)
              ]),
              (_unref(org).document)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-sm text-zinc-400" }, "Documento", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(formatDocument(_unref(org).document)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-sm text-zinc-400" }, "Senha", -1)),
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "sm",
                  class: "text-xs text-zinc-400 hover:text-white gap-1.5 -mr-2 h-7",
                  onClick: openChangePassword
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(KeyRound), { class: "h-3.5 w-3.5" }),
                    _cache[12] || (_cache[12] = _createTextVNode(" Alterar "))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Percent), { class: "h-5 w-5 text-emerald-400" })
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-base font-semibold text-white" }, "Taxas da Plataforma"),
                _createElementVNode("p", { class: "text-xs text-zinc-500 mt-0.5" }, "Valor retido sobre cada venda processada")
              ], -1))
            ]),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_unref(Bot), { class: "h-4 w-4 text-violet-400" })
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-sm font-semibold text-zinc-200" }, "Taxa do Bot Padrão", -1))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-zinc-500 mb-1" }, "Percentual", -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(firstIntegration.value?.splitPercentage != null ? firstIntegration.value.splitPercentage + '%' : '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-zinc-500 mb-1" }, "Valor fixo adicional", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(firstIntegration.value?.splitAmount != null ? formatCurrency(firstIntegration.value.splitAmount) : '—'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_unref(GitBranch), { class: "h-4 w-4 text-emerald-400" })
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-sm font-semibold text-zinc-200" }, "Taxa do Bot Fluxo de Chat", -1))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "bg-white/3 rounded-lg px-4 py-3" }, [
                        _createElementVNode("p", { class: "text-xs text-zinc-500 mb-1" }, "Percentual"),
                        _createElementVNode("span", { class: "text-xl font-bold text-white" }, "0%")
                      ], -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-xs text-zinc-500 mb-1" }, "Valor fixo por venda", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(firstIntegration.value?.flowSplitAmount != null ? formatCurrency(firstIntegration.value.flowSplitAmount + firstIntegration.value.splitAmount) : '—'), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_unref(Loader2), { class: "w-5 h-5 animate-spin text-zinc-500" })
                ]))
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_unref(Bell), { class: "h-5 w-5 text-emerald-400" })
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-base font-semibold text-white" }, "Notificações"),
                _createElementVNode("p", { class: "text-xs text-zinc-500 mt-0.5" }, "Receba um aviso no navegador quando algo importante acontecer.")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_36, [
              (notificationPermission.value !== 'granted')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_unref(BellOff), { class: "h-4 w-4 flex-shrink-0" }),
                      _cache[22] || (_cache[22] = _createTextVNode(" Ative as notificações do navegador para receber os avisos. "))
                    ]),
                    _createVNode(_unref(Button), {
                      size: "sm",
                      onClick: handleEnableNotifications
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("Ativar notificações")
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_unref(Label), { class: "mb-3 block" }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Som de notificação de venda")
                  ])),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(soundOptions, (sound) => {
                    return _createElementVNode("button", {
                      key: sound.id,
                      type: "button",
                      onClick: ($event: any) => (handleSelectSound(sound.id)),
                      class: _normalizeClass(["flex flex-col items-center gap-2 rounded-lg border px-3 py-3 transition-colors", notificationSound.value === sound.id ? 'border-emerald-500 bg-emerald-500/10' : 'border-white/10 bg-white/5 hover:bg-white/10'])
                    }, [
                      _createVNode(_unref(Volume2), {
                        class: _normalizeClass(["h-4 w-4", notificationSound.value === sound.id ? 'text-emerald-400' : 'text-zinc-400'])
                      }, null, 8, ["class"]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-xs", notificationSound.value === sound.id ? 'text-white' : 'text-zinc-400'])
                      }, _toDisplayString(sound.label), 3)
                    ], 10, _hoisted_40)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                    _createElementVNode("p", { class: "text-sm font-medium text-white" }, "Venda aprovada"),
                    _createElementVNode("p", { class: "text-xs text-zinc-500" }, "Avisar quando um pagamento for confirmado.")
                  ], -1)),
                  _createVNode(_unref(Switch), {
                    checked: notificationPreferences.value.sale,
                    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((notificationPreferences.value.sale) = $event))
                  }, null, 8, ["checked"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", null, [
                    _createElementVNode("p", { class: "text-sm font-medium text-white" }, "Pix gerado (venda pendente)"),
                    _createElementVNode("p", { class: "text-xs text-zinc-500" }, "Avisar quando um cliente gerar um Pix aguardando pagamento.")
                  ], -1)),
                  _createVNode(_unref(Switch), {
                    checked: notificationPreferences.value.pendingSale,
                    "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((notificationPreferences.value.pendingSale) = $event))
                  }, null, 8, ["checked"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                    _createElementVNode("p", { class: "text-sm font-medium text-white" }, "Bot fora do ar"),
                    _createElementVNode("p", { class: "text-xs text-zinc-500" }, "Avisar quando um dos seus bots parar de responder.")
                  ], -1)),
                  _createVNode(_unref(Switch), {
                    checked: notificationPreferences.value.botDown,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((notificationPreferences.value.botDown) = $event))
                  }, null, 8, ["checked"])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_unref(Button), {
                  disabled: isSavingNotifications.value,
                  onClick: handleSaveNotifications
                }, {
                  default: _withCtx(() => [
                    (isSavingNotifications.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _cache[28] || (_cache[28] = _createTextVNode(" Salvar notificações "))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Dialog), {
      open: isChangePasswordOpen.value,
      "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((isChangePasswordOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-md" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("Alterar senha")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode(" Preencha os campos abaixo para redefinir sua senha de acesso. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("Senha atual "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  type: "password",
                  modelValue: passwordForm.value.passwordOld,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((passwordForm.value.passwordOld) = $event)),
                  placeholder: "••••••••",
                  autocomplete: "current-password"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("Nova senha "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  type: "password",
                  modelValue: passwordForm.value.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((passwordForm.value.password) = $event)),
                  placeholder: "••••••••",
                  autocomplete: "new-password"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("Confirmar nova senha "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  type: "password",
                  modelValue: passwordForm.value.passwordConfirm,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordForm.value.passwordConfirm) = $event)),
                  placeholder: "••••••••",
                  autocomplete: "new-password"
                }, null, 8, ["modelValue"])
              ]),
              (passwordError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                    _createVNode(_unref(AlertCircle), { class: "h-3.5 w-3.5 flex-shrink-0" }),
                    _createTextVNode(" " + _toDisplayString(passwordError.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  class: "text-white",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (isChangePasswordOpen.value = false))
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isChangingPassword.value || !passwordForm.value.passwordOld || !passwordForm.value.password || !passwordForm.value.passwordConfirm,
                  onClick: handleChangePassword
                }, {
                  default: _withCtx(() => [
                    (isChangingPassword.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _cache[36] || (_cache[36] = _createTextVNode(" Salvar "))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})